import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AiOffCalendarItem, AiOffCalendarItemView, toAiOffCalendarItemView } from './ai-settings.model'
import * as state from './ai-settings.state'
import * as lodash from 'lodash'
import { toMoment } from '@tokeet-frontend/tv3-platform'

export const State = createFeatureSelector<state.State>('aiSettings')

export const selectAISettingsLoaded = createSelector(State, (state: state.State) => state.isLoaded)
export const selectAISettingsIsSaving = createSelector(State, (state: state.State) => state.isSaving)
export const selectAISettings = createSelector(State, (state: state.State) => state.settings)

export const selectAISettingsDocs = createSelector(State, (state: state.State) => state.settings?.docs || [])

export const selectAISettingsDisabledHours = createSelector(
  State,
  (state: state.State) => state.settings?.disabledHours || []
)

export const selectAISettingsDisabledHoursView = createSelector(
  selectAISettingsDisabledHours,
  (items: AiOffCalendarItem[]) => {
    return lodash.map(items, toAiOffCalendarItemView)
  }
)

export const selectAIOffCalendarItemsForDate = (date: number) =>
  createSelector(selectAISettingsDisabledHoursView, (items: AiOffCalendarItemView[]) => {
    return lodash.filter(items, (item) => {
      return !item.all && toMoment(date).isBetween(item.start, item.end, 'date', '[]')
    })
  })

export const selectAIOffCalendarItemsWithoutDate = (date: number) =>
  createSelector(selectAISettingsDisabledHoursView, (items: AiOffCalendarItemView[]) => {
    return lodash.filter(items, (item) => {
      return item.all || !toMoment(date).isBetween(item.start, item.end, 'date', '[]')
    })
  })

export const selectAIOffCalendarItemsForAllDays = createSelector(
  selectAISettingsDisabledHoursView,
  (items: AiOffCalendarItemView[]) => {
    return lodash.filter(items, (item) => item.all)
  }
)
